import React from 'react';
import { Alert } from "react-bootstrap";
import { Check2Circle } from 'react-bootstrap-icons';

class AlertSuccessComponent extends React.Component {
    render() {
        return (
          <Alert variant="success">
            <Check2Circle size={16} className="mb-1 me-1 text-success" />{this.props.label}
          </Alert>
        );
    }
}

export default AlertSuccessComponent;